export default __webpack_public_path__ + "static/media/enterprise-icon.0484b02f.svg";